import { Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SocialBrandIcon } from "@/src/common/components/social-brand-icon";
import { SITE_CONFIG } from "@/src/common/constants/site-config";

export function ContactInfo() {
	const { t } = useTranslation("contact");

	return (
		<div className="rounded-3xl border border-default-200/60 bg-content1/60 p-8">
			<h3 className="text-lg font-semibold text-foreground">{t("info.title")}</h3>
			<ul className="mt-6 space-y-5">
				<li className="flex items-start gap-3">
					<span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500/10 text-brand-600">
						<Mail className="h-4 w-4" />
					</span>
					<div>
						<p className="text-xs uppercase tracking-wide text-default-500">{t("info.email_label")}</p>
						<a
							href={`mailto:${SITE_CONFIG.contactEmail}`}
							className="mt-1 block text-base font-medium text-foreground hover:text-brand-600"
						>
							{SITE_CONFIG.contactEmail}
						</a>
					</div>
				</li>
				<li className="flex items-start gap-3">
					<span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500/10 text-brand-600">
						<SocialBrandIcon name="linkedin" size={16} />
					</span>
					<div>
						<p className="text-xs uppercase tracking-wide text-default-500">{t("info.linkedin_label")}</p>
						<a
							href={SITE_CONFIG.socials.linkedin}
							target="_blank"
							rel="noreferrer"
							className="mt-1 block text-base font-medium text-foreground hover:text-brand-600"
						>
							@upsquad
						</a>
					</div>
				</li>
				<li className="flex items-start gap-3">
					<span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500/10 text-brand-600">
						<SocialBrandIcon name="x" size={14} />
					</span>
					<div>
						<p className="text-xs uppercase tracking-wide text-default-500">{t("info.x_label")}</p>
						<a
							href={SITE_CONFIG.socials.x}
							target="_blank"
							rel="noreferrer"
							className="mt-1 block text-base font-medium text-foreground hover:text-brand-600"
						>
							@upsquad
						</a>
					</div>
				</li>
				<li className="flex items-start gap-3">
					<span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-xl bg-brand-500/10 text-brand-600">
						<MapPin className="h-4 w-4" />
					</span>
					<div>
						<p className="text-xs uppercase tracking-wide text-default-500">Office</p>
						<p className="mt-1 text-base font-medium text-foreground">{t("info.office")}</p>
					</div>
				</li>
			</ul>
		</div>
	);
}
